import { ref } from 'vue';

export interface ToastItem {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message?: string;
  duration?: number;
}

const toasts = ref<ToastItem[]>([]);

export function useToastNotification() {
  const showToast = (
    type: 'success' | 'error' | 'warning' | 'info',
    title: string,
    message?: string,
    duration = type === 'error' ? 5000 : 3500
  ) => {
    const id = `toast_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    toasts.value.push({ id, type, title, message, duration });

    setTimeout(() => {
      removeToast(id);
    }, duration);
  };

  const removeToast = (id: string) => {
    toasts.value = toasts.value.filter(t => t.id !== id);
  };

  return {
    toasts,
    showToast,
    removeToast,
    notifySuccess: (title: string, msg?: string) => showToast('success', title, msg),
    notifyError: (title: string, msg?: string) => showToast('error', title, msg),
    notifyWarning: (title: string, msg?: string) => showToast('warning', title, msg),
    notifyInfo: (title: string, msg?: string) => showToast('info', title, msg),
  };
}
